import { render, staticRenderFns } from "./ForeignCurrencyHandleDiscountDataTable.vue?vue&type=template&id=48aa63c7&scoped=true"
import script from "./ForeignCurrencyHandleDiscountDataTable.vue?vue&type=script&lang=js"
export * from "./ForeignCurrencyHandleDiscountDataTable.vue?vue&type=script&lang=js"
import style0 from "./ForeignCurrencyHandleDiscountDataTable.vue?vue&type=style&index=0&id=48aa63c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aa63c7",
  null
  
)

export default component.exports